<template>
  <div class="row mt-2 pb-3">
    <div class="col-md-12 pt-3">
      <div class="container-fluid">
        <div class="row mobile-row">
          <div class="col-md-4 col-6">
            <div class="info-text-title">
              Autor:
            </div>
            <p class="info-text">
              {{ book.author ? book.author : '-' }}
            </p>
          </div>
          <div class="col-md-4 col-6">
            <div class="info-text-title">
              ISBN:
            </div>
            <p class="info-text">
              {{ book.isbn ? book.isbn : '-' }}
            </p>
          </div>
          <div class="col-md-4 col-6">
            <div class="info-text-title">
              Casa Editora:
            </div>
            <p class="info-text">
              {{ book.publisher ? book.publisher : '-' }}
            </p>
          </div>
          <template v-if="isManagementBook">
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Fecha de Pedido:
              </div>
              <p class="info-text">
                {{ book.requestDate ? formatDate(book.requestDate) : '-' }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Tipo de Pedido:
              </div>
              <p class="info-text">
                {{ book.requested ? 'Sí' : 'No' }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Razón de Pedido:
              </div>
              <p class="info-text">
                {{ book.requestReason ? book.requestReason : '-' }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Medio de Lectura:
              </div>
              <p class="info-text">
                {{ book.readingMedium ? book.readingMedium : '-' }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Razón de No Compra :
              </div>
              <p class="info-text">
                {{ purchaseReasonName(book) }}
              </p>
            </div>
            <div v-if="showDeliveredDate" class="col-md-4 col-6">
              <div class="info-text-title">
                Fecha de Entrega:
              </div>
              <p class="info-text">
                {{ book.deliveredDate ? formatDate(book.deliveredDate) : '-' }}
              </p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import purchaseReasonDesc from '@/utils/constants/book/purchaseReasonsDesc.js';
import purchaseReasonTypes from '@/utils/constants/book/purchaseReasons.js';
import { studentBookStatus } from '@/utils/constants/book/studentBookStatus';

export default {
  name: 'BookInfo',
  components: {},
  props: {
    book: {
      type: Object,
      required: true,
    },
    isManagementBook: {
      type: Boolean,
    },
  },
  computed: {
    purchaseReasonName() {
      return (value) => {
        if (value.purchaseReasonCode) {
          const reasonName = purchaseReasonDesc.filter(
            (x) => x.id === value.purchaseReasonCode
          )[0].value;
          if (
            value.purchaseReasonCode ===
            purchaseReasonTypes.IntercambioDeEscuela
          ) {
            return `${reasonName} (${value.purchaseSchoolName})`;
          } else if (
            value.purchaseReasonCode === purchaseReasonTypes.IntercambioDeCentro
          ) {
            return `${reasonName} (${value.purchaseCenterName})`;
          } else {
            return `${reasonName}`;
          }
        } else {
          return '-';
        }
      };
    },
    showDeliveredDate() {
      return (
        this.book.statusId == studentBookStatus.Entregado ||
        this.book.statusId == studentBookStatus.Procesado
      );
    },
  },
  data() {
    return {
      studentBookStatus,
    };
  },
  methods: {
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY')
        .replace('.', '');
    },
  },
};
</script>

<style scoped>
.info-text {
  color: #11291b !important;
}
.info-text-title {
  color: #727272 !important;
  font-size: 14px !important;
  font-weight: normal;
}

@media only screen and (max-width: 375px) {
  .info-text-title {
    color: #727272 !important;
    font-size: 12px !important;
    font-weight: normal;
  }
  .info-text {
    color: #11291b !important;
    font-weight: normal;
    font-size: 12px;
  }
}
</style>
